import './Header.css';
import logo from '../assets/Silwren_logo.png';

export default function Header() {
  return (
    <header className="sil-header">
      <div className="sil-header-inner">
        <div className="sil-logo">
          <div className="sil-logo-box">
            <img src={logo} alt="Silwren" />
          </div>
          {/* Silwren™ */}
        </div>
        <nav className="sil-nav">
          <a href="/">Home</a>
          <a href="/about">About Us</a>
          
          {/* <a href="#agents">Smart Agents</a>
          <a href="#vision">Neural Networks</a>
          <a href="#robotics">Robotics</a> */}
        </nav>
        {/* <button className="sil-btn">Request Demo</button> */}
      </div>
    </header>
  );
}